import Api from '@/services/Api'

export default {
  getOrders () {
    return Api().get('api/orders')
  },
  getOrder (id) {
    return Api().post('api/orders/find', id)
  },
  updateOrderStatus (statusUpdate) {
    return Api().post('api/orders/update', statusUpdate)
  },
  getCSV () {
    return Api().get('api/orders/csv')
  }
}



// WEBPACK FOOTER //
// ./src/services/OrdersService.js